let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hDfPU")).then(() => parcelRequire('2mD8T'));